import { Message } from 'element-ui';
import { dispatchPrint, dispatchBatchPrint, updatePrintCount, batchUpdatePrintCount } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';

// 当前组件上下文
let componentContext = null;
/**
 * @description 判断待缓存数据是否为有效值
 */
export const isEmpty = (value) => {
    return value === null || value === undefined || value === '' || ['[]', '{}'].includes(JSON.stringify(value));
};

/**
 * @description 从本地存储读取数据
 */
export const getLocalStorage = (key) => {
    if (!key) return;
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
};

/**
 * @description 写入数据到本地存储
 * @param {String} key 键名
 * @param {String|Object} value 键值
 */
export const setLocalStorage = (key, value) => {
    if (!key || isEmpty(value)) return;
    localStorage.setItem(key, JSON.stringify(value));
};

/**
 * @description 处理打印逻辑
 * @param {Object} ctx 当前组件上下文
 * @param {Object} params 打印参数
 */
export const handleDispatchPrint = (ctx, params, close = false) => {
    componentContext = ctx; // 保存当前组件上下文
    componentContext.btnLoading = true;
    dispatchPrint(params)
        .then(res => {
            if (res && +res.code === 0) {
                if (res.data && res.data.length) {
                    handleUpdatePrintCount(params, res.data);
                    close && componentContext.beforeClose();
                };
            }
        })
        .finally(() => {
            componentContext.btnLoading = false;
        });
};

/**
 * @description 更新打印次数
 * @param {Object} params 更新打印接口参数
 * @param {String} url 打印的链接
 */
export const handleUpdatePrintCount = (params, data) => {
    return updatePrintCount(params).then(res => {
        if (res && +res.code === 0) {
            data.forEach(item => {
                item.url && window.open(item.url);
            });
        };
    });
};

/**
 * @description 打印校验
 * @param {Array} data 打印模板数据
 */
export const checkedDataValidated = data => {
    const checkedData = data.filter(v => v.checkedTemplate && v.checkedTemplate.length);
    if (!checkedData.length) {
        Message.warning('至少选择一个打印单');
        return false;
    }
    return true;
};

/**
 * @description 处理批量打印逻辑
 * @param {Object} ctx 当前组件上下文
 * @param {Object} params 打印参数
 */
export const handleBatchDispatchPrint = (ctx, params, close = false) => {
    componentContext = ctx; // 保存当前组件上下文
    componentContext.btnLoading = true;
    dispatchBatchPrint(params)
        .then(res => {
            if (res && +res.code === 0) {
                if (res.data && res.data.length) {
                    handleUpdateBatchPrintCount(params, res.data);
                    close && componentContext.beforeClose();
                };
            }
        })
        .finally(() => {
            componentContext.btnLoading = false;
        });
};

/**
 * @description 更新打印次数
 * @param {Object} params 更新打印接口参数
 * @param {String} url 打印的链接
 */
export const handleUpdateBatchPrintCount = (params, data) => {
    return batchUpdatePrintCount(params).then(res => {
        if (res && +res.code === 0) {
            data && window.open(data);
        };
    });
};
// /**
//  * @description 文件上传OSS获取预览链接
//  * @param {String} url 打印的链接
//  */
// const submitUpload = (url) => {
//     fetch(url).then(async res => {
//         if (res) {
//             const fileName = url.split('/').pop();
//             const pdfBlob = await res.blob();
//             const formData = new FormData();
//             formData.append('file', pdfBlob, fileName);
//             formData.append('bucket', 'c-tms');
//             formData.append('businessKey', 'default');
//             formData.append('publicRead', 1);
//             formData.append('contentType', 'application/pdf');
//             ossUpload(formData)
//                 .then((res) => {
//                     if (res && +res.code === 0) {
//                         res.data.downUrl && window.open(res.data.downUrl);
//                     }
//                 })
//                 .catch(() => { });
//         }
//     }).catch(() => { });
// };
